<svg
  width="60"
  height="61"
  viewBox="0 0 60 61"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="30" cy="30.5" r="25" fill="var(--vlt-lp-accent-text)" />
  <path
    d="M30 5.5c-13.785 0-25 11.215-25 25s11.215 25 25 25 25-11.215 25-25-11.215-25-25-25Zm-4.997 36.032L15.72 32.27l3.53-3.54 5.747 5.738 13.236-13.236 3.535 3.535-16.765 16.765Z"
    fill="var(--vlt-lp-accent)"
  />
</svg>
